<!--
 * @Descripttion: 德运通天然气管理系统
 * @version: 1.0.0
 * @Author: xst
 * @Date: 2020-03-31 13:00:48
 * @LastEditors: xst

 -->
<template>
  <div>
    <p class="pagetitle">
      <i class="fa fa-th"></i>
      快捷方式
    </p>
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="card kjfs">
          <p class="title2"><i class="el-icon-deytjichuxinxiguanli1"></i>基础信息</p>
          <ul>
            <li><router-link to="/companyList" class="kjfs kjfs-bluee"><span><i class="el-icon-deytgongsi2"></i></span><span>公司列表</span></router-link></li>
            <li><router-link to="/roleList" class="kjfs kjfs-pinkk"><span><i class="el-icon-deytkerenxinxiguanli1"></i></span><span>角色列表</span></router-link></li>
             <li><router-link to="/staffList" class="kjfs kjfs-grennn"><span><i class="el-icon-deytyewurenyuanxinxiguanli"></i></span><span>人员列表</span></router-link></li>
          </ul>
          <ul>

            <li><router-link to="/accountList" class="kjfs kjfs-purplee"><span><i class="el-icon-deytfenghuangxiangmutubiao_quanxian"></i></span><span>账户列表</span></router-link></li>
             <li><router-link to="/handoverList" class="kjfs kjfs-yelloww"><span><i class="el-icon-deytbiaoxinxiguanli"></i></span><span>挂牌库列表</span></router-link></li>
            <li></li>
            <!-- <li><router-link to="/markdown" class="kjfs kjfs-lightBluee"><span><i class="fa fa-file-code-o fa-2x"></i></span><span>自定义功能实现</span></router-link></li> -->
          </ul>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="card kjfs">
          <p class="title2"><i class="el-icon-deytxiangmu1"></i>合同管理</p>
          <ul>
            <li><router-link to="/contractIndex" class="kjfs kjfs-bluee"><span><i class="el-icon-deythetong2"></i></span><span>我的合同</span></router-link></li>
           <li><router-link to="/contract" class="kjfs kjfs-grennn"><span><i class="el-icon-deytxinxiguanli"></i></span><span>合同列表</span></router-link></li>
            <li><router-link to="/contractMould" class="kjfs kjfs-yelloww"><span><i class="el-icon-deythetong1"></i></span><span>合同模板</span></router-link></li>
          </ul>
          <ul>
             <li><router-link to="/newcontract" class="kjfs kjfs-pinkk"><span><i class="el-icon-deytxinjianwendang"></i></span><span>新建合同</span></router-link></li>

            <li><router-link to="/newsupply" class="kjfs kjfs-purplee"><span><i class="el-icon-deytxinjianmulu"></i></span><span>新建补充合同</span></router-link></li>
            <li></li>
            <!-- <li><router-link to="#" class="kjfs kjfs-lightBluee"><span><i class="fa fa-file-code-o fa-2x"></i></span><span>查看合同</span></router-link></li> -->
          </ul>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="card kjfs">
          <p class="title2"><i class="el-icon-deyttongji1"></i>每日挂牌</p>
          <ul>
            <li><router-link to="/day" class="kjfs kjfs-bluee"><span><i class="el-icon-deytcaijingrili"></i></span><span>每日挂牌价</span></router-link></li>
            <li><router-link to="/newDaily" class="kjfs kjfs-pinkk"><span><i class="el-icon-deyttongji"></i></span><span>新建挂牌价</span></router-link></li>
          </ul>
          <ul>
            <li><router-link to="/dailyCompute" class="kjfs kjfs-grennn"><span><i class="el-icon-deyticon1"></i></span><span>挂牌价计算器</span></router-link></li>
            <li></li>
          </ul>
        </div>
      </el-col>
    </el-row>
   <el-row :gutter="20" style='margin-top:18px;'>
     <el-col :span="8">
       <div class="card kjfs">
         <p class="title2"><i class="el-icon-deytxiaoshou-"></i>销售管理</p>
         <ul>
           <li><router-link to="/mySell" class="kjfs kjfs-bluee"><span><i class="el-icon-deytxiaoshoudingdan"></i></span><span>我的销售单</span></router-link></li>
           <li><router-link to="/sellList" class="kjfs kjfs-pinkk"><span><i class="el-icon-deytxiaoshoudanguanli"></i></span><span>销售单列表</span></router-link></li>
           <li><router-link to="/innerCheckList" class="kjfs kjfs-grennn"><span><i class="el-icon-deytxiaoshoudanju"></i></span><span>销售单核对</span></router-link></li>
         </ul>
         <ul>
           <li><router-link to="/newSellGaugeTicket" class="kjfs kjfs-purplee"><span><i class="el-icon-deytnavicon-jldwsz"></i></span><span>新建计量单</span></router-link></li>
           <li><router-link to="/sellGaugeTicketList" class="kjfs kjfs-yelloww"><span><i class="el-icon-deytnavicon-jldw"></i></span><span>销售计量单</span></router-link></li>
           <li></li>
           <!-- <li><router-link to="/markdown" class="kjfs kjfs-lightBluee"><span><i class="fa fa-file-code-o fa-2x"></i></span><span>自定义功能实现</span></router-link></li> -->
         </ul>
       </div>
     </el-col>
     <el-col :span="8">
       <div class="card kjfs">
         <p class="title2"><i class="el-icon-deytjiesuantongjibiao"></i>结算管理</p>
         <ul>
           <li><router-link to="/mySettlement" class="kjfs kjfs-bluee"><span><i class="el-icon-deytfeiyongjiesuandan"></i></span><span>我的结算单</span></router-link></li>
           <li><router-link to="/metering" class="kjfs kjfs-pinkk"><span><i class="el-icon-deytjiesuandanliebiao"></i></span><span>计量结算单</span></router-link></li>
           <li><router-link to="/unusualMetering" class="kjfs kjfs-grennn"><span><i class="el-icon-deytrizhiyichang"></i></span><span>异常计量单</span></router-link></li>
         </ul>
         <ul>
           <li><router-link to="/beinvoice" class="kjfs kjfs-purplee"><span><i class="el-icon-deytfapiaoguanli1"></i></span><span>待开票列表</span></router-link></li>
           <li><router-link to="/receivableList" class="kjfs kjfs-yelloww"><span><i class="el-icon-deytfapiaoguanli"></i></span><span>收款项列表</span></router-link></li>
           <li><router-link to="/otherExpenses" class="kjfs kjfs-lightBluee"><span><i class="el-icon-deytRectangleCopy2"></i></span><span>其他费用列表</span></router-link></li>
         </ul>
       </div>
     </el-col>
     <el-col :span="8">
       <div class="card bbxx">
         <p class="title2"><i class="fa fa-server"></i>版本信息</p>
         <div class="table">
           <p><span class="tit">项目名称</span>
             德运通天然气运营管理系统
           </p>
           <p><span class="tit">当前版本</span>v1.0.0</p>
           <p><span class="tit">基于框架</span>vue全家桶 +webpack+axios+element-ui</p>
           <p><span class="tit">主要特色</span>高效 极简 / 动态权限 / 可视化数据方案 / 数据源树型管理</p>

         </div>
       </div>
     </el-col>
    </el-row>
    <rank-dialog ></rank-dialog>
  </div>
</template>

<script>
// import LineEcharts from '../../components/ECharts/lineEcharts'
import RankDialog from "./rankDialog.vue";
export default {
  name: 'mainIndex',
  components: {RankDialog},
  // components: {Maintable, LineEcharts},
  mounted () {
    this.selfAdaption()
  },
  methods: {
    // echart自适应
    selfAdaption () {
      let that = this
      setTimeout(() => {
        window.onresize = function () {
          if (that.$refs.echarts) {
            that.$refs.echarts.chart.resize()
          }
        }
      }, 10)
    }
  }
}
</script>

<style lang="scss" scoped>
  $top:top;
  $bottom:bottom;
  $left:left;
  $right:right;
  $leftright: ($left, $right);
  $pinkk: #eec2d3;
  $bluee: #409eff;
  $yelloww: #f4d884;
  $grennn: #89dda0;
  $purplee: #78a2ea;
  $lightBluee: #b37fde;

  $list: bluee pinkk yelloww grennn purplee lightBluee;
  $list1: $bluee $pinkk $yelloww $grennn $purplee $lightBluee;
  %shadow{
    background: #fff;
    -webkit-box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.2);
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.2);
    border-color: rgba(0, 0, 0, 0.2);
    .title2{
      font-size: 19px;
      padding:10px 10px 10px;
      i{
        margin-#{$right}: 5px;
        font-size: 21px;
      }
    }
  }

  @mixin flex($direction:row,$content:space-between){
    display: flex;
    flex-direction: $direction;
    justify-content: $content;
  }
  .card{
    color: #666;
    @extend %shadow;

    ul{
      @include flex;
      li{
        flex: 1;
        a{
          color: #666666;
          align-items:center;
          padding-#{$top}: 10px;
          padding-#{$bottom}: 10px;
          @include flex(column);
          span:first-child{
            height:40px;line-height: 40px;
            i{
              font-size: 26px;
            }
          }
          span:last-child{height: 30px;}
          .num{
            line-height: 44px;
            font-size: 42px;
            color: $bluee;
            margin: 0px;
          }
        }
        .kjfs-bluee{
          color: $bluee;
        }
        .kjfs-pinkk{
          color: $pinkk;
        }
        .kjfs-yelloww{
          color: $yelloww;
        }
        .kjfs-grennn{
          color: $grennn;
        }
        .kjfs-purplee{
          color: $purplee;
        }
        .kjfs-lightBluee{
          color: $lightBluee;
        }
        &:hover{
          .kjfs-bluee{
            color: #ffffff;
            background: $bluee;
          }
          .kjfs-pinkk{
            color: #ffffff;
            background: $pinkk;
          }
          .kjfs-yelloww{
            color: #ffffff;
            background: $yelloww;
          }
          .kjfs-grennn{
            color: #ffffff;
            background: $grennn;
          }
          .kjfs-purplee{
            color: #ffffff;
            background: $purplee;
          }
          .kjfs-lightBluee{
            color: #ffffff;
            background: $lightBluee;
          }
        }
      }
    }
    .table{
      padding: 8px 10px;
      p{
        height:39.5px;
        line-height: 39.5px;
        border: 1px solid #cccccc;
        overflow: hidden;
        border-#{$top}: none;
        @include flex( null,start);
        &:first-child{
          border-#{$top}: 1px solid #cccccc;
        }

        .tit{
          width: 90px;
          min-width: 90px;
          height: 100%;
          text-align: center;
          border-#{$right}: 1px solid #cccccc;
          margin-#{$right}: 18px;
        }
        span.gitbox{
          flex: 1;
          height: 100%;
          overflow: hidden;
          @include flex(row,start);
          a{
            &:first-child{
              margin-#{$right}: 30px;
            }
          }
        }
      }
    }
  }
  #lineEcharts{
    margin-#{$top}: 30px;
    padding-#{$top}: 30px;
    @extend %shadow;
  }
  #maintable{
    margin-#{$top}: 30px;
    padding-#{$top}: 10px;
    @extend %shadow;
  }
  .pagetitle {
  font-size: 28px;
  margin-bottom: 24px;
}
.el-icon-deytgongsi2 {
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/mainIndex.vue